import { USER_ROLES } from "@playarena/shared";

import { FormatedUserRole, UserRole, UserRoleConfigs } from "@/types/user";

export const formatPhoneNumber = (phone: string): string => {
  const cleaned = phone.replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phone;
};

export const formatSeatNumber = (seatId: string): string => {
  // Assuming seatId format: "section-row-number"
  const parts = seatId.split("-");
  if (parts.length >= 3) {
    return `${parts[1]}${parts[2]}`;
  }
  return seatId;
};

export const formatCapacity = (capacity: number): string => {
  if (capacity >= 1000000) {
    return `${(capacity / 1000000).toFixed(1)}M`;
  }
  if (capacity >= 1000) {
    return `${(capacity / 1000).toFixed(1)}K`;
  }
  return capacity.toString();
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const formatPercentage = (value: number, total: number): string => {
  if (total === 0) return "0%";
  return `${Math.round((value / total) * 100)}%`;
};

export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + "...";
};

export const capitalizeFirst = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatBookingReference = (reference: string): string => {
  return reference.replace(/(.{2})/g, "$1-").slice(0, -1);
};

export const formatRole = (role: UserRole): FormatedUserRole => {
  switch (role) {
    case "fan":
      return "Fan";
    case "manager":
      return "Ground Manager";
    case "organizer":
      return "Event Organizer";
    case "superadmin":
      return "Super Admin";
    default:
      return "Fan";
  }
};

export const getUserRoles = ({
  hiddenRoles,
  disabledRoles,
}: {
  hiddenRoles?: UserRole[];
  disabledRoles?: UserRole[];
}): UserRoleConfigs[] => {
  return (Object.values(USER_ROLES) as UserRole[])
    .filter(r => !hiddenRoles?.includes(r))
    .map(role => ({
      role,
      label: formatRole(role),
      isDisabled: !!disabledRoles?.includes(role),
    }));
};
